import { load } from '@/util/router-utils.js'
import client from '../client'

export default [
  {
    path: 'consultants',
    component: load('app/super-admin/consultants/Index')
  },
  {
    path: 'clients',
    component: load('app/super-admin/clients/Index')
  },
  {
    path: 'activities',
    component: load('app/super-admin/activities/Index')
  },
  {
    path: 'mixer-db',
    component: load('app/super-admin/mixer-base/Index'),
    children: [
      {
        path: '',
        name: 'MixersView',
        component: load('app/super-admin/mixer-base/MixersView')
      },
      {
        path: ':mixerId/models',
        name: 'MixerModels',
        component: load('app/super-admin/mixer-base/ModelsView/ModelsView'),
        props: true
      },
      {
        path: ':mixerId/models/:modelId/calibrations',
        name: 'CalibrationsView',
        component: load('app/super-admin/mixer-base/CalibrationsView/CalibrationsView'),
        props: true
      }
    ]
  },

  {
    path: 'clients/:client_id',
    redirect: 'clients/:client_id/companies'
  },
  ...client.map(item => ({
    ...item,
    path: `clients/:client_id/${item.path}`
  }))
]
